// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__mJ2Zc","wrapper":"Footer_wrapper__1j5Fk","text":"Footer_text__2odME"};